import { injectable, multiInject } from 'inversify';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

let AnalyticsProvider = class AnalyticsProvider {};
AnalyticsProvider = __decorate([injectable()], AnalyticsProvider);

let Analytics = class Analytics {
  constructor(providers) {
    this.providers = providers;
  }
  identify(user) {
    if (!user) return;
    this.providers.forEach(provider => {
      provider.identify(user);
    });
  }
  track(event, properties) {
    this.providers.forEach(provider => {
      provider.track(event, properties);
    });
  }
  page(event, properties) {
    this.providers.forEach(provider => {
      provider.page(event, properties);
    });
  }
};
Analytics = __decorate([injectable(), __param(0, multiInject(AnalyticsProvider)), __metadata("design:paramtypes", [Array])], Analytics);

/**
 * Note: most *Clicked events happens when the user clicks on the "Continuar"
 * button. This button is enabled when the UI is in a valid state (for more
 * details, take a look at the `CanStep` component), so these events are only
 * registered when the UI was without frontend validation errors.
 */
const AnalyticsEvent = {
  CHECKOUT: {
    VIEWED: 'CheckoutPaymentViewed',
    SUBMITTED: 'CheckoutPurchaseSubmitted',
    SUCCESSFUL: 'CheckoutPurchaseSuccessful',
    FAILED: 'CheckoutPurchaseFailed',
    REJECTED: 'CheckoutPurchaseRejected',
    INSERT_COUPON_SUCCESS: 'CheckoutInsertCouponSuccess',
    INSERT_COUPON_FAILURE: 'CheckoutInsertCouponFailure',
    SUBSCRIPTION_PLAN_VIEWED: 'CheckoutSubscriptionPlanViewed',
    SUBSCRIPTION_PLAN_CHANGE_CLICKED: 'CheckoutSubscriptionPlanChangeClicked',
    SUBSCRIPTION_PLAN_CLICKED: 'CheckoutSubscriptionPlanClicked',
    PAYMENT_METHOD_VIEWED: 'CheckoutPaymentMethodViewed',
    // Change means choosing another payment method, while edit means editting
    // the details of the current payment method.
    PAYMENT_METHOD_CHANGE_CLICKED: 'CheckoutPaymentMethodChangeClicked',
    PAYMENT_METHOD_EDIT_CLICKED: 'CheckoutPaymentMethodEditClicked',
    PAYMENT_METHOD_CLICKED: 'CheckoutPaymentMethodClicked',
    CREDIT_CARD_DETAILS_VIEWED: 'CheckoutCreditCardDetailsViewed',
    CREDIT_CARD_DETAILS_CLICKED: 'CheckoutCreditCardDetailsClicked',
    PERSONAL_INFO_VIEWED: 'CheckoutPersonalInfoViewed',
    PERSONAL_INFO_EDIT_CLICKED: 'CheckoutPersonalInfoEditClicked',
    PERSONAL_INFO_CLICKED: 'CheckoutPersonalInfoClicked',
    LOGIN_VIEWED: 'CheckoutLoginViewed',
    LOGIN_SEND_CODE_CLICKED: 'CheckoutLoginSendCodeClicked',
    CONFIRMATION_VIEWED: 'CheckoutConfirmationViewed',
    BUY_CLICKED: 'CheckoutBuyClicked',
    UPSELL_VIEWED: 'CheckoutUpsellViewed',
    UPSELL_PLAN_SELECTED: 'UpsellPlanSelected',
    UPSELL_NEXT_CLICKED: 'CheckoutUpsellNextClicked',
    UPSELL_CANCEL_CLICKED: 'CheckoutUpsellCancelClicked',
    UPSELL_INSTALLMENTS_VIWED: 'CheckoutUpsellInstallmentsViwed',
    UPSELL_SUBMITTED: 'CheckoutUpsellSubmitted',
    UPSELL_INSTALLMENTS_CANCEL_CLICKED: 'CheckoutUpsellInstallmentsCancelClicked',
    ORDER_BUMP_ADD_CLICKED: 'CheckoutOrderBumpAddClicked',
    WITHOUT_LOGIN: {
      USER_WITH_MULTIPLE_ACCOUNTS: 'CheckoutWithoutLoginUserWithMultipleAccounts'
    }
  },
  CHANGE_PAYMENT_METHOD: {
    SUBMITTED: 'MemberDashboardChangePaymentMethodSubmitted',
    SUCCESSFUL: 'MemberDashboardChangePaymentMethodSuccesful',
    REJECTED: 'MemberDashboardChangePaymentMethodRejected',
    VIEWED: 'MemberDashboardChangePaymentMethodViewed'
  },
  CHANGE_PLAN: {
    SUBMITTED: 'MemberDashboardChangePlanSubmitted',
    SUCCESSFUL: 'MemberDashboardChangePlanSuccesful',
    REJECTED: 'MemberDashboardChangePlanRejected',
    VIEWED: 'SubscriptionPlanIntervalViewed'
  },
  HUB: {
    VIEWED: 'MyContentPageViewed',
    SUBMITTED: 'ContentPostSubmitted',
    SUCCESSFUL: 'ContentPostSubmittedSucessFull',
    FAILED: 'ContentPostSubmittedSucessFailed',
    REJECTED: 'ContentPageErrorViewed',
    CANCELED: 'ContentPageCancelDialogClicked',
    REMOVED: 'ContentPageRemoveDialogClicked',
    ALERT: 'ContentPageAlertViewed',
    CANCEL_DIALOG: 'ContentPageCancelDialogClicked'
  },
  MAIN_MENU: {
    PROFILE_CLICKED: 'WebMainMenuProfileClicked',
    EDIT_PROFILE_CLICKED: 'WebMainMenuEditProfileClicked',
    PRODUCTS_CLICKED: 'WebMainMenuMyProductsClicked',
    PURCHASES_CLICKED: 'WebMainMenuMyPurchasesClicked',
    VERIFICATION_ACCOUNT_CLICKED: 'WebMainMenuVerificationAccountClicked',
    BANK_ACCOUNT_CLICKED: 'WebMainMenuBankAccountClicked',
    AFFILIATES_CLICKED: 'WebMainMenuAffiliateSalesClicked',
    SUPPORT_CLICKED: 'WebMainMenuFAQClicked',
    BLOG_CLICKED: 'WebMainMenuBlogClicked',
    GUIDE_CLICKED: 'WebMainMenuGuideClicked',
    LOGOUT_CLICKED: 'WebMainMenuLogoutClicked',
    COLLABORATORS_CLICKED: 'WebMainMenuCollaboratorsClicked',
    ROLEPLAY_CLICKED: 'WebMainMenuRoleplayClicked'
  },
  ANALYTICS: {
    GENERAL_FILTER_PRODUCT_CLICKED: 'GeneralFilterProductClicked',
    GENERAL_FILTER_COMPARASION_CLICKED: 'GeneralFilterComparisonClicked',
    GROWTH: {
      VIEWED: 'ReportGrowthViewed',
      TOOLTIP_ACTIVE_SUBSCRIBERS_GRAPHIC_CLICKED: 'ToolTipActiveSubscribersGraphicClicked',
      HOVER_ACTIVE_SUBSCRIBERS_GRAPHIC_CLICKED: 'HoverActiveSubscribersGraphicClicked',
      HOVER_SUBTITLE_ACTIVE_SUBSCRIBERS_GRAPHIC_CLICKED: 'HoverSubtitleActiveSubscribersGraphicClicked',
      TOOLTIP_GROSS_REVENUE_CLICKED: 'ToolTipGrossRevenueClicked',
      SEGMENT_GROSS_REVENUE_CLICKED: 'SegmentGrossRevenueClicked',
      HOVER_GRAPHIC_GROSS_REVENUE_CLICKED: 'HoverGraphicGrossRevenueClicked',
      HOVER_SUBTITLE_GROSS_REVENUE_CLICKED: 'HoverSubtitleGrossRevenueClicked',
      METRIC_GROWTH_ANALYSIS_TABLE_CLICKED: 'MetricGrowthAnalysisTableClicked',
      SEGMENT_METRIC_GROWTH_ANALYSIS_TABLE_CLICKED: 'SegmentMetricGrowthAnalysisTableClicked',
      VISUALIZATION_GROWTH_ANALYSIS_METRICS_CLICKED: 'VisualizationGrowthAnalysisMetricsClicked',
      HOVER_GRAPHIC_GROWTH_ANALYSIS_CLICKED: 'HoverGraphicGrowthAnalysisClicked',
      HOVER_SUBTITLE_GROWTH_ANALYSIS_CLICKED: 'HoverSubtitleGrowthAnalysisClicked',
      TOOLTIP_NEW_MEMBERS_GRAPHIC_CLICKED: 'ToolTipNewMembersGraphicClicked',
      HOVER_NEW_MEMBERS_GRAPHIC_CLICKED: 'HoverNewMembersGraphicClicked',
      HOVER_SUBTITLE_NEW_MEMBERS_GRAPHIC_CLICKED: 'HoverSubtitleNewMembersGraphicClicked',
      TOOTLIP_RECURRING_REVENUE_GRAPHIC_CLICKED: 'ToolTipRecurringRevenueGraphicClicked',
      HOVER_GRAPHIC_RECURRING_REVENUE_CLICKED: 'HoverGraphicRecurringRevenueClicked',
      HOVER_SUBTITLE_RECURRING_REVENUE_GRAPHIC_CLICKED: 'HoverSubtitleRecurringRevenueGraphicClicked'
    },
    RETENTION: {
      VIEWED: 'ReportRetentionViewed',
      DOWNLOAD_SUBSCRIBERS_LOST_CLICKED: 'DownloadSubscribersLostClicked',
      CONTACT_SUBSCRIBERS_LOST_CLICKED: 'ContactSubscribersLostClicked',
      DOWNLOAD_TOP_SUBSCRIBERS_CLICKED: 'DownloadTopSubscribersClicked',
      CONTACT_TOP_SUBSCRIBERS_CLICKED: 'ContactTopSubscribersClicked',
      VISUALIZATION_CHURN_TABLE_CLICKED: 'VisualizationChurnTableClicked',
      SEGMENT_CHURN_TABLE_CLICKED: 'SegmentChurnTableClicked',
      TOOLTIP_CHURN_RATE_CLICKED: 'ToolTipChurnRateClicked',
      SEGMENT_CHURN_RATE_CLICKED: 'SegmentChurnRateClicked',
      HOVER_GRAPHIC_CHURN_RATE_CLICKED: 'HoverGraphicChurnRateClicked',
      HOVER_SUBTITLE_CHURN_RATE_CLICKED: 'HoverSubtitleChurnRateClicked',
      TOOLTIP_REVENUE_LOSTPER_CHURN_CLICKED: 'ToolTipRevenueLostperChurnClicked',
      SEGMENT_REVENUE_POSTPER_CHURN_CLICKED: 'SegmentRevenueLostperChurnClicked',
      HOVER_GRAPHIC_REVENUE_LOSTPER_CHURN_CLICKED: 'HoverGraphicRevenueLostperChurnClicked',
      HOVER_SUBTITLE_REVENUE_LOSTPER_CHURN_CLICKED: 'HoverSubtitleRevenueLostperChurnClicked'
    }
  },
  SCHEDULED_COMMUNICATION: {
    CHANGE_PAYMENT_METHOD: {
      VIEWED: {
        WHATSAPP: 'PaymentChangePageViewedThroughWhatsappLink',
        EMAIL: 'PaymentChangePageViewedThroughEmailLink',
        UNKNOWN: 'PaymentChangePageViewedThroughUnknownLink'
      },
      SUBMITTED: {
        WHATSAPP: 'PaymentChangePageSubmittedThroughWhatsappLink',
        EMAIL: 'PaymentChangePageSubmittedThroughEmailLink',
        UNKNOWN: 'PaymentChangePageSubmittedThroughUnknownLink'
      }
    }
  },
  WALLET: {
    REQUEST_WITHDRAWAL_POPUP_CLICKED: 'WalletRequestWithdrawalPopupClicked',
    REQUEST_WITHDRAWAL_CLICKED: 'WalletRequestWithdrawalClicked',
    MOVEMENT_CLICKED: 'WalletMovementClicked',
    TAB_CLICKED: 'WalletTabClicked',
    EXPORT_POPUP_CLICKED: 'WalletExportPopupClicked',
    EXPORT_CLICKED: 'WalletExportClicked',
    INTERVAL_CHANGED: 'WalletIntervalChanged',
    TRANSACTION_TYPE_FILTER: 'WalletTransactionTypeFilter',
    VIEWED: 'WalletViewed'
  },
  LOGIN_PREFERENCES: {
    NAVIGATION_TARGET: {
      CREATOR_CLICKED: 'LoginPreferencesNavigationTargetCreatorClicked',
      BUYER_CLICKED: 'LoginPreferencesNavigationTargetBuyerClicked',
      CHANGE_TO_CREATOR_CLICKED: 'LoginPreferencesNavigationTargetChangeToCreatorClicked',
      CHANGE_TO_BUYER_CLICKED: 'LoginPreferencesNavigationTargetChangeToBuyerClicked'
    }
  },
  PUBLIC_INVOICE: {
    VIEWED: 'PublicInvoiceViewed',
    PAYMENT_SUBMITTED: 'PublicInvoicePaymentSubmitted',
    PAYMENT_ERROR: 'PublicInvoicePaymentError'
  }
};

let AnalyticsMock = class AnalyticsMock extends Analytics {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  track(event, properties) {}
};
AnalyticsMock = __decorate([injectable()], AnalyticsMock);

let AnalyticsProviderMock = class AnalyticsProviderMock extends AnalyticsProvider {
  identify(user) {}
  page(event, properties) {}
  track(event, properties) {}
};
AnalyticsProviderMock = __decorate([injectable()], AnalyticsProviderMock);

export { Analytics, AnalyticsEvent, AnalyticsMock, AnalyticsProvider, AnalyticsProviderMock };
